// libraries
import React, { useEffect, useState } from 'react'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'

// utils
import { useSmoothScroll } from '/lib/reactutils/utils'

interface FooterProps {
    // logoColor?: 'text-light' | 'text-dark' | string;
    logoSvg: string;
    logoHref: string;
    logoAriaLabel: string;
    // companyName?: string;
    // contact?: Array<{ title: string, text: string }>;
    // address?: Array<{ title: string, text: string }>;
    topics: Array<{ name: string; link: string; external?: boolean }>;
    subTopics: Array<{ name: string, link: string, external?: boolean }>;
    socialMedia: Array<{ name: string, icon: string, href: string, external?: boolean }>;
    socialIcon?: string;
    copyright: Array<{ text: string, year: number }>;
    ariaLabel?: string;
    target?: string;
    custormerPortal: { name: string, link: string, external?: boolean };
    signIn?: { name: string, link: string, icon?: string };
}

export default function Footer({
    logoSvg,
    logoHref,
    logoAriaLabel,
    topics,
    subTopics,
    socialMedia,
    socialIcon,
    copyright,
    ariaLabel,
    target,
    custormerPortal,
    signIn
}: FooterProps) {

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        handleResize(); // Set initial state
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getSubTopicSlices = () => {
        if (isMobile) {
            return {
                slice1: subTopics.slice(0, 4),
                slice2: subTopics.slice(4, 8),
                slice3: subTopics.slice(8, 12),
            };
        } else {
            return {
                slice1: subTopics.slice(0, 3),
                slice2: subTopics.slice(3, 6),
                slice3: subTopics.slice(6, 9),
            };
        }
    };

    const subTopicSlices = getSubTopicSlices();

    // smooth scroll (when clicking the anchor links)
	const smoothScrollTo = useSmoothScroll()

	const smoothScroll = (e) => {
		e.preventDefault()
		const targetId = e.currentTarget.getAttribute('href').substring(1)
    	smoothScrollTo(targetId)
	}

    return (

        <footer id='footer'  >
            <Section className='footer'>

                <div className='grid-container'>
                    <div className='grid-row footer__wrapper'>
                        <div className="c-12">
                            <Button
                                rightIcon='ArrowUp'
                                color='light'
                                className='footer__back-to-top'
                                href='#main'
                                onClick={smoothScroll}
                                ariaLabel='Back to top'
                            />
                        </div>
                        <div className="c-12 c-md-4 footer__logo">
                            <a
                                href={logoHref}
                                aria-label={logoAriaLabel}
                                className='logo'
                                dangerouslySetInnerHTML={{ __html: logoSvg }}
                                suppressHydrationWarning
                            />
                        </div>
                        <div className="c-12 start-md-5 c-md-3 footer__topic">
                            {topics && topics.length > 0 && (
                                <ul className='footer__topic-list--1'>
                                    {topics.slice(0, 3).map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={item.external}
                                                menuBtn='topic'
                                                className='hover-underline'
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="c-12 c-md-3 footer__topic">
                            {topics && topics.length > 0 && (
                                <ul className='footer__topic-list--2'>
                                    {topics.slice(3, 6).map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={item.external}
                                                menuBtn='topic'
                                                className='hover-underline'
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        {
                            (custormerPortal.name || signIn?.name) &&
                            <div className="c-12 c-md-2 footer__topic footer__button">
                                {custormerPortal.name &&
                                    <Button
                                        color='light'
                                        size='md'
                                        className='btn__nobreak'
                                        rightIcon=''
                                        href={custormerPortal.link}
                                        target={custormerPortal.external}
                                    >
                                        {custormerPortal.name}
                                    </Button>
                                }
                                {signIn?.name &&
                                    <Button
                                        color='light'
                                        size='md'
                                        className='btn__nobreak'
                                        href={signIn.link}
                                        target={true}
                                    >
                                        {signIn.name}
                                        {signIn.icon && <span
                                            className="btn__icon btn__icon--right"
                                            dangerouslySetInnerHTML={{ __html: signIn.icon }}
                                        />}
                                    </Button>
                                }
                            </div>
                        }
                        <div className="c-md-8 footer__divider"></div>
                        <div className="c-xxs-6 start-md-5 c-md-3 footer__subtopic">
                            {subTopicSlices.slice1.length > 0 && (
                                <ul className='footer__subtopic-list--1'>
                                    {subTopicSlices.slice1.map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={item.external}
                                                menuBtn='sub-topic'
                                                className='hover-underline'
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="c-xxs-6 c-md-3 footer__subtopic footer__subtopic--2">
                            {subTopicSlices.slice2.length > 0 && (
                                <ul className='footer__subtopic-list--2'>
                                    {subTopicSlices.slice2.map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={item.external}
                                                menuBtn='sub-topic'
                                                className='hover-underline'
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="c-md-2 footer__subtopic">

                            {subTopicSlices.slice3.length > 0 && (
                                <ul className='footer__subtopic-list'>
                                    {subTopicSlices.slice3.map((item, i) => (
                                        <li key={i}>
                                            <Button
                                                href={item.link}
                                                target={item.external}
                                                menuBtn='sub-topic'
                                                className='hover-underline'
                                            >
                                                {item.name}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                    <div className="c-md-8 footer__divider footer__divider--mobile"></div>

                    <div className="grid-row">
                        <div className="c-12 footer__social">
                            <p className='footer__copyright'>
                                {copyright.map((item, i) => (
                                    <span key={i}>{item.text}{item.year}</span>
                                ))}
                            </p>
                            {socialMedia && socialMedia.length > 0 && (
                                <ul className='footer__social-list'>
                                    {socialMedia.map((item, i) => (
                                        <li key={i}>
                                            <a
                                                href={item.href}
                                                aria-label={item.name}
                                                className='btn__social'
                                                dangerouslySetInnerHTML={{ __html: item.icon }}
                                                suppressHydrationWarning
                                                target='_blank'
                                            />
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </Section>
        </footer>
    );
}
